const budgetCommercialHeader = [
  {
    group: 'Orçamento BTLeo Líquido',
    columns: [
      {
        name: 'Id',
        id: 'orcamento-id',
        show: false
      },
      {
        name: 'Ano',
        id: 'orcamento-ano',
        show: true
      },

      {
        name: 'Mes',
        id: 'orcamento-mes',
        show: false
      },
      {
        name: 'Empresa',
        id: 'orcamento-empresa',
        show: true
      },
      {
        name: 'Loja',
        id: 'orcamento-loja',
        show: true
      },
      {
        name: 'Categoria',
        id: 'orcamento-categoria',
        show: true
      },
      {
        name: 'Fator Venda Bruta',
        id: 'orcamento-fator-venda',
        show: true
      },
      {
        name: 'Real + Proj. Ano Atual',
        id: 'orcamento-real-proj',
        show: true
      },
      {
        name: 'Previsão Orçamento',
        id: 'orcamento-prev-orcamento',
        show: true
      },
      {
        name: '',
        id: 'orcamento-alterado',
        show: true
      },
      {
        name: 'Crescimento (%)',
        id: 'orcamento-crescimento',
        show: true
      },
      {
        name: 'Orçamento Ajustado',
        id: 'orcamento-ajustado',
        show: true
      },
      {
        name: 'Crescimento Ajustado',
        id: 'orcamento-crescimento-ajustado',
        show: true
      }
    ]
  },
  {
    group: 'Orçamento Dias Úteis',
    columns: [
      {
        name: 'Real + Proj. Ano Atual',
        id: 'orcamento-du-real-proj',
        show: true
      },
      {
        name: 'Previsão Orçamento',
        id: 'orcamento-du-prev-orcamento',
        show: true
      },
      {
        name: 'Orçamento Ajustado',
        id: 'orcamento-du-ajustado',
        show: true
      },
      {
        name: 'Crescimento Ajustado',
        id: 'orcamento-du-crescimento-ajustado',
        show: true
      }
    ]
  }
]

export default budgetCommercialHeader
